import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  borderRadius: (p) => p.spacing(1),
  position: 'relative',
};

export const cardContent: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(1),
  '&.MuiCardContent-root:last-child': { paddingBottom: 1 },
};
